// assets/swatch-colors.js
(() => {
    if (window.__SWATCHES_INIT__) return;
    window.__SWATCHES_INIT__ = true;

    const SPECIALS = {
        'khaki': '#C3B091',
        'khaki green': '#78866B'
    };

    const isColor = (t) =>
        !!t && (/^(#|rgb|hsl)/i.test(t) || (window.CSS && CSS.supports && CSS.supports('color', t)));

    const normalize = (token) => {
        if (!token) return '';
        const raw = String(token).trim();
        const key = raw.toLowerCase();
        if (SPECIALS[key]) return SPECIALS[key];
        return isColor(raw) ? raw : raw;
    };

    function applySwatches(root = document) {
        // Работает и со старыми фильтрами, и с поисковой страницей
        const nodes = root.querySelectorAll('label.filter-group__item[data-swatch], [data-swatch].swatch, [data-swatch]');
        nodes.forEach(el => {
            const raw = el.getAttribute('data-swatch');
            if (!raw) return;

            if (raw.includes('/')) {
                const [a, b] = raw.split('/').map(s => normalize(s));
                el.style.setProperty('--swatch-background-color', 'transparent');
                el.style.setProperty('--swatch-background-image', `linear-gradient(90deg, ${a} 50%, ${b} 50%)`);
            } else {
                const c = normalize(raw);
                el.style.setProperty('--swatch-background-image', 'none');
                el.style.setProperty('--swatch-background-color', c);
            }
        });
    }

    // Экспорт для ручного вызова при необходимости
    window.Swatches = { apply: applySwatches };

    const observe = () => {
        const mo = new MutationObserver(muts => {
            for (const m of muts) {
                m.addedNodes && m.addedNodes.forEach(n => {
                    if (n.nodeType === 1) applySwatches(n);
                });
            }
        });
        mo.observe(document.body, { childList: true, subtree: true });
    };

    document.addEventListener('DOMContentLoaded', () => {
        applySwatches();
        observe();
    });

    document.addEventListener('shopify:section:load', (e) => applySwatches(e.target));
})();
